import { render, staticRenderFns } from "./critical-projects.vue?vue&type=template&id=1686897f&scoped=true"
import script from "./critical-projects.vue?vue&type=script&lang=js"
export * from "./critical-projects.vue?vue&type=script&lang=js"
import style0 from "./critical-projects.vue?vue&type=style&index=0&id=1686897f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1686897f",
  null
  
)

export default component.exports